import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  cessationDate: Yup.date().required("Cessation date is required"),
  letterOfResignation: Yup.object().shape({
    modeType: Yup.string().required("Letter of resignation type is required"),
    subModeType: Yup.string().when("modeType", {
      is: "not-signed-documents",
      then: Yup.string().required("Sub mode type is required"),
    }),
  }),
  statutoryDeclaration: Yup.object().shape({
    modeType: Yup.string().required("Statutory declaration type is required"),
    subModeType: Yup.string().when("modeType", {
      is: "not-signed-documents",
      then: Yup.string().required("Sub mode type is required"),
    }),
  }),
});
